import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
    static values = {
        url: String,
        name: String,
        email: String
    }

    open(event) {
        event.preventDefault()

        Swal.fire({
            title: "Approve charity",
            html: `
        <p class="mb-3">Send the approval email to <strong>${this.escapeHtml(this.nameValue)}</strong>?</p>
        <input
          id="charity-approval-email"
          type="email"
          class="swal2-input"
          placeholder="Primary email"
          value="${this.escapeHtml(this.emailValue || "")}"
        />
      `,
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, approve",
            cancelButtonText: "Cancel",
            focusConfirm: false,
            preConfirm: () => {
                const email = document.getElementById("charity-approval-email")?.value?.trim()

                if (!email) {
                    Swal.showValidationMessage("Email is required.")
                    return false
                }

                return { email }
            }
        }).then((result) => {
            if (!result.isConfirmed) return
            this.submit(result.value.email)
        })
    }

    async submit(email) {
        const token = document.querySelector('meta[name="csrf-token"]')?.content

        const response = await fetch(this.urlValue, {
            method: "POST",
            headers: {
                "X-CSRF-Token": token,
                "Accept": "text/vnd.turbo-stream.html",
                "Content-Type": "application/json"
            },
            body: JSON.stringify({ email })
        })

        const html = await response.text()
        Turbo.renderStreamMessage(html)
    }

    escapeHtml(value) {
        const div = document.createElement("div")
        div.textContent = value
        return div.innerHTML
    }
}